import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { SuccessStoryCategoryList } from './SuccessStoryCategoryList';
import { SuccessStoryCategoryDatagrid } from './SuccessStoryCategoryDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { SuccessStoryCategory } from './SuccessStoryCategory';

export * from './SuccessStoryCategory';
export * from './SuccessStoryCategoryCreate';
export * from './SuccessStoryCategoryDatagrid';
export * from './SuccessStoryCategoryEdit';
export * from './SuccessStoryCategoryList';
export * from './SuccessStoryCategoryShow';

const SuccessStoryCategoriesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'name', header: 'שם / כותרת' },
	// { key: 'description', header: 'תיאור' },
	{ key: 'imageUrl', header: 'תמונה' },
	{ key: 'organization.name', header: 'ארגון' }
];

export const SuccessStoryCategoriesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: SuccessStoryCategory) => entity;

	const successStoryCategoriesFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('קטגוריות סיפורי הצלחה', exportFields, exportDataMapper)}
				{...props}
				filters={successStoryCategoriesFilter}
				bulkActionButtons={<SuccessStoryCategoriesBulkActionButtons/>}
				title="SUCCESS_STORY_CATEGORIES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <SuccessStoryCategoryList/> : <SuccessStoryCategoryDatagrid/>}
			</List>
		</Fragment>
	);
};
